export async function uploadImage(context, imageData) {
  return context.rootState.app.broker.fetchAndTransform({
    fn: 'uploadImageToCloudinary',
    params: imageData,
  });
}
